<template>
    <m-main-layout>
        <el-button size="small" type="primary" slot="right-btn" @click="$router.push({path:'/user/vip/list'})">返回列表</el-button>
        <div class="page-content-main">
            <el-form :model="formData" status-icon :rules="rules" ref="form" label-width="auto" class="margin-top" style="width:600px;">
                <el-form-item label="等级名称" prop="title">
                    <el-input v-model="formData.title" maxlength="20" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="唯一等级值" prop="vip_level">
                    <el-input v-model="formData.vip_level" maxlength="20" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="唯一标识" prop="i_key">
                    <el-input v-model="formData.i_key" maxlength="20" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="图标" prop="icon">
                    <div class="el-upload el-upload--picture-card margin-right rel margin-bottom hide" v-show="formData.icon">
                        <img :src="formData.icon.indexOf('http://') >= 0 || formData.icon.indexOf('https://') >= 0 ? formData.icon+'!thumb' : $config.assetsUrl+formData.icon" style="width:100%;vertical-align: middle;"/>
                        <span class="miihe-upload-item">
                            <span @click="showVipIconImg(formData.icon)"><i class="el-icon-zoom-in"></i></span>
                            <span @click="delVipIconImg"><i class="el-icon-delete"></i></span>
                        </span>
                    </div>
                    <image-dialog :limit="5" :min="0" :max="1" :data="formData.icon ? [formData.icon] : []" @on-choose="onChooseVipIconImage" showType="block" imgKey="vipIcon">添加图片</image-dialog>
                    <el-dialog :visible.sync="vipIconImgIsShow">
                        <img width="100%" :src="vipIconImgUrl" alt="">
                    </el-dialog>
                    建议尺寸 180*180
                </el-form-item>
                <el-form-item label="背景类型"  prop="bg_type">
                    <el-select placeholder="请选择" v-model="formData.bg_type" @change="changeBgType">
                        <el-option label="颜色" value="color"></el-option>
                        <el-option label="图片" value="image"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="背景" prop="bg" v-if="formData.bg_type === 'color'">
                    <el-color-picker v-model="formData.bg"></el-color-picker>
<!--                    <el-input v-model="formData.bg" maxlength="20" show-word-limit></el-input>-->
                </el-form-item>
                <el-form-item label="背景" prop="bg" v-if="formData.bg_type === 'image'">
                    <div class="el-upload el-upload--picture-card margin-right rel margin-bottom hide" v-show="formData.bg">
                        <img :src="$config.assetsUrl+formData.bg" style="width:100%;vertical-align: middle;"/>
                        <span class="miihe-upload-item">
                            <span @click="showBigImg(formData.bg)"><i class="el-icon-zoom-in"></i></span>
                            <span @click="delBigImg"><i class="el-icon-delete"></i></span>
                        </span>
                    </div>
                    <image-dialog :limit="5" :min="0" :max="1" :data="formData.bg ? [formData.bg] : []" @on-choose="onChooseBgImage" showType="block" imgKey="vipBg">添加图片</image-dialog>
                    <el-dialog :visible.sync="bigImgIsShow">
                        <img width="100%" :src="bigImgUrl" alt="">
                    </el-dialog>
                </el-form-item>
                <el-form-item label="购物折扣率" prop="goods_percent">
                    <el-input v-model="formData.goods_percent">
                        <template slot="append">%</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="优惠券使用比例" prop="quan_use_percent">
                    <el-input v-model="formData.quan_use_percent">
                        <template slot="append">%</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="赠券周期" prop="quan_time">
                    <el-select placeholder="请选择" v-model="formData.quan_time">
                        <el-option label="每周" value="week"></el-option>
                        <el-option label="每月" value="month"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="赠券数量" prop="quan_count">
                    <el-input v-model.number="formData.quan_count">
                        <template slot="append">元</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="抽奖次数" prop="jiang_times">
                    <el-input v-model.number="formData.jiang_times">
                        <template slot="append">次</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="众筹分润比例" prop="crowd_percent">
                    <el-input v-model="formData.crowd_percent">
                        <template slot="append">%</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="同时发起众筹次数" prop="crowd_times">
                    <el-input v-model.number="formData.crowd_times">
                        <template slot="append">次</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="排序" prop="sort">
                    <el-input v-model="formData.sort"style="width:300px;"></el-input>
                </el-form-item>
                <el-form-item label="默认等级" prop="is_default">
                    <el-switch
                            v-model="formData.is_default"
                            active-color="#13ce66"
                            active-value="1"
                            inactive-value="0"
                            active-text="是"
                            inactive-text="否">
                    </el-switch>
                </el-form-item>
                <el-form-item label="状态" prop="state">
                    <el-switch
                            v-model="formData.state"
                            active-color="#13ce66"
                            active-value="1"
                            inactive-value="0"
                            active-text="启用"
                            inactive-text="禁用">
                    </el-switch>
                </el-form-item>
                <el-form-item label="说明" prop="des">
                    <el-input v-model="formData.des" type="textarea" maxlength="200" show-word-limit style="width:300px;" :rows="4"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('form')">确定</el-button>
                    <el-button type="" @click="$router.back()">返回</el-button>
                </el-form-item>
            </el-form>
        </div>
    </m-main-layout>
</template>

<script>
    export default {
        name: "VipAdd",
        data() {
            return {
                formData: {
                    title:'',
                    bg:'',
                    bg_type:'color',
			        goods_percent:0,
			        quan_time:'',
			        quan_count:0,
			        jiang_times:0,
			        crowd_percent:0,
			        crowd_times:0,
			        des:'',
                    sort:'0',
                    state:'1',
	                is_default:'0',
                    icon:'',
	                i_key:'',
	                vip_level:0,
	                quan_use_percent:0
                },
	            bigImgUrl: '',
	            bigImgIsShow: false,
	            vipIconImgUrl: '',
	            vipIconImgIsShow: false,
	            typeList:[],
                rules: {
	                title: [
                        { required: true},
                    ],
	                bg: [
		                { required: true},
	                ],
	                bg_type: [
		                { required: true},
	                ],
	                goods_percent: [
		                { required: true},
	                ],
	                quan_time: [
		                { required: true},
	                ],
	                quan_count: [
		                { required: true,validator:  this.$utils.biggerZero},
	                ],
	                jiang_times: [
		                { required: true,validator:  this.$utils.biggerZero},
	                ],
	                crowd_percent: [
		                { required: true},
	                ],
	                crowd_times: [
		                { required: true,validator:  this.$utils.biggerZero},
	                ],
	                des: [
		                { required: true},
	                ],
	                state: [
		                { required: true},
	                ],
	                sort: [
		                { required: true},
	                ],
	                icon: [
		                { required: true},
	                ],
	                i_key: [
		                { required: true,validator:this.$utils.mustLetter},
	                ],
	                vip_level: [
		                { required: true,validator:this.$utils.mustNumber},
	                ],
	                quan_use_percent: [
		                { required: true,validator:this.$utils.rulePercent},
	                ],
                },
            };
        },
        methods: {
	        changeBgType(){
		        this.formData.bg = '';
	        },
	        onChooseBgImage(e){
		        this.formData.bg = e[0];
	        },
	        showBigImg(item){
		        this.bigImgUrl = item.indexOf('http://') >= 0 || item.indexOf('https://') >= 0 ? item : this.$config.assetsUrl+item;
		        this.bigImgIsShow = true;
	        },
	        delBigImg(){
		        this.formData.bg = '';
	        },
	        onChooseVipIconImage(e){
		        this.formData.icon = e[0];
	        },
	        showVipIconImg(item){
		        this.vipIconImgUrl = this.$config.assetsUrl+item;
		        this.vipIconImgIsShow = true;
	        },
	        delVipIconImg(){
		        this.formData.icon = '';
	        },
            submitForm(formName) {
                let _this = this;
	            console.log(_this.formData);
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                    	console.log(_this.formData);
                    	_this.$http.httpPost({
                            url:'Vip/add',
                            datas:_this.formData,
                            success:(res)=>{
	                            _this.$router.replace({path: '/user/vip/list'})
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            }
        }
    }
</script>
